import apiClient from './config';

export default {
  // Connexion admin
  login(credentials) {
    return apiClient.post('/admin/login', {
      email: credentials.email,
      mot_de_passe: credentials.password || credentials.mot_de_passe
    });
  },

  // Inscription entreprise (super admin)
  register(data) {
    return apiClient.post('/admin/create-super-admin', {
      nom: data.nom,
      prenom: data.prenom,
      email: data.email,
      telephone: data.telephone,
      mot_de_passe: data.password || data.mot_de_passe,
      nom_societe: data.nom_societe,
      siret: data.siret,
      adresse: data.adresse,
      telephone_firm: data.telephone_firm,
      email_firm: data.email_firm,
      type_compte: data.type_compte || 'solo',
      type_tarification: data.type_tarification || 'flexible',
      montant_abonnement: data.montant_abonnement || 35
    });
  },

  // Vérifier le token
  verifyToken() {
    return apiClient.get('/auth/verify-token');
  },

  // Réinitialisation du mot de passe
  requestPasswordReset(email) {
    return apiClient.post('/admin/reset-password', { email });
  },

  // Mettre à jour le mot de passe
  updatePassword(token, passwords) {
    return apiClient.post(`/admin/update-password/${token}`, passwords);
  },

  // Changer le mot de passe (depuis les paramètres)
  changePassword(data) {
    return apiClient.put('/admin/change-password', data);
  },

  // Connexion Google Calendar
  connectGoogleCalendar(code) {
    return apiClient.post('/admin/google-connect', { code });
  },

  // Déconnexion Google Calendar
  disconnectGoogleCalendar() {
    return apiClient.post('/admin/google-disconnect');
  },

  // Récupérer le profil utilisateur
  getProfile() {
    return apiClient.get('/admin/profil');
  },

  // Récupérer les informations de la firme
  getFirmInfo() {
    return apiClient.get('/admin/firm-info');
  },

  // Mettre à jour le profil
  updateProfile(data) {
    return apiClient.put('/admin/modifier', data);
  },

  // Déconnexion
  logout() {
    localStorage.removeItem('token');
    return Promise.resolve();
  },

  // Google OAuth - Inscription/Connexion avec Google
  googleAuth(googleToken) {
    return apiClient.post('/admin/google-auth', { token: googleToken });
  },

  // Compléter l'inscription après Google OAuth
  completeGoogleRegistration(data, tempToken) {
    return apiClient.post('/admin/complete-google-registration', {
      nom_societe: data.nom_societe,
      siret: data.siret,
      adresse: data.adresse,
      telephone_firm: data.telephone_firm,
      email_firm: data.email_firm,
      type_compte: data.type_compte || 'solo',
      nombre_employes: data.nombre_employes || 1,
      telephone: data.telephone || '',
      type_tarification: data.type_tarification || 'flexible',
      montant_abonnement: data.montant_abonnement || 14.99
    }, {
      headers: tempToken ? { Authorization: `Bearer ${tempToken}` } : {}
    });
  },

  // Obtenir le palier Lifetime actuel
  getLifetimeTier() {
    return apiClient.get('/admin/lifetime-tier');
  },

  // ========================================
  // Routes de parrainage
  // ========================================

  // Récupérer les informations de parrainage de l'utilisateur
  getReferralInfo() {
    return apiClient.get('/admin/referral/info');
  },

  // Valider un code de parrainage
  validateReferralCode(referralCode) {
    return apiClient.post('/admin/referral/validate', { referralCode });
  },

  // Appliquer un parrainage (après inscription)
  applyReferralCode(referralCode) {
    return apiClient.post('/admin/referral/apply', { referralCode });
  },
};
